import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardCurrentComponent, PropertyDashboardComponent, DashboardFutureComponent } from './pages';
import {
  StepsForPlanningComponent,
  DashboardPastDisplayComponent,
  DashboardFutureDisplayComponent, DashboardCurrentDisplayComponent, DashboardCurrentIntegrationDisplayComponent
} from './components';
import { SharedModule } from '../../shared';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InternalSharedModule } from '../shared';
import { DashboardPastComponent } from './pages/dashboard-past';
import { ReportsModule } from '../reports';
import { DxChartModule } from 'devextreme-angular/ui/chart';
import { DxPopoverModule } from 'devextreme-angular/ui/popover';
import { DxPieChartModule } from 'devextreme-angular/ui/pie-chart';

@NgModule({
  declarations: [
    /* Layouts */

    /* Pages */
    DashboardCurrentComponent,
    DashboardPastComponent,
    DashboardFutureComponent,
    PropertyDashboardComponent,

    /* Components */
    DashboardCurrentDisplayComponent,
    DashboardCurrentIntegrationDisplayComponent,
    DashboardFutureDisplayComponent,
    DashboardPastDisplayComponent,
    StepsForPlanningComponent,
  ],
  exports: [
    PropertyDashboardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    InternalSharedModule,
    DxChartModule,
    DxPopoverModule,
    DxPieChartModule,    
    RouterModule,
    SharedModule,
    ReportsModule,
  ]
})
export class DashBoardModule { }
